import React, { useMemo, useRef } from "react";
import {
  faCircleExclamation,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Loader from "../../Layout/Loader";
import func, { isObjectEmpty, sellerPartyToConnection, validateInvoice } from "../../../services/functions";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import mainAxios from "../../../services/mainAxios";
import AsyncSelect from "react-select/async";
import { Tooltip } from "primereact/tooltip";
import { Dialog } from "primereact/dialog";
import EditAddSupplies from "../../Setup/Contacts/EditAddContact";
import { partiesDialogTypes } from "../../../services/data";
import TaxPayerSearch from "../../global/TaxPayerSearch";
import MySuppliers from "../../Setup/Contacts/Contacts";
import { compactSelect } from "../../../design/selectStyle";


const DemoParties = ({ invoiceState, setInvoiceState, disabled, errors , setErrors,partiesDialog, setPartiesDialog,edit,stateDefault}) => {

  const inputRef = useRef(null);
  const inputRefSeller = useRef(null);
  const { t } = useTranslation("translations");
  const [customers, setCustomers] = React.useState("");
  const sellerVisible=partiesDialog.open && partiesDialog.party==partiesDialogTypes.seller
  const buyerVisible=partiesDialog.open && partiesDialog.party==partiesDialogTypes.buyer


  const handlePartyTypeChange = (party,taxPayer) => {
    let { name, town, address, country, tin } = taxPayer
    setInvoiceState((invoiceState) => ({
      ...invoiceState,
      parties: {
        ...invoiceState.parties,
        [party]: {
          ...taxPayer,
          name,
          town,
          address,
          country,
          [party=="seller"?"sellerIDType":"buyerIDType"]: "NUIS",
        },
      },
    }))
  }

  const onSellerChange=(taxPayer)=>{
    if((invoiceState.selfInvoice || correctionOfSelfInvoice)){
      handlePartyTypeChange("seller",taxPayer)
    }
  }

  const onBuyerChange=(taxPayer)=>{
      if (
        invoiceState.parties.seller.tin === taxPayer.tin &&
        invoiceState.profileId != "P10" &&
        invoiceState.profileId != "P12"
      ) {
        toast.error(t(["toast.diffNipt"]), { containerId: "all_toast" });
      }
      handlePartyTypeChange("buyer",taxPayer)
  }


  const loadOptionsForContacts = async (name,contactType) => {

    const sortCriteria=[{
      field: "recordDate",
      direction: "DESC"
    }]

    let customers=[];
    if (name.length > 2) {
      return await mainAxios
      .post("/apiEndpoint/search", {
        object: "GetConnections",
        value: null,
        params: {
          customerLiveSearch:name,
          "contactTypes.type": contactType,
        },
        sortCriteria
      })
        .then((res) => {
          if(res.data.status){
            customers = res.data.content.map((el) => {
              const {name,idValue:tin}=el
              return {
                ...el,
                label: name + " - " + tin,
                value: name,
              };
            });
          }

          return customers;
        });
    }
  };

  const sellerIDTypes = [
    { label: "NUIS", value: "1" },
    { label: "ID", value: "2" },
    { label: "PASS", value: "3" },
    { label: "VAT", value: "4" },
    { label: "TAX", value: "5" },
    { label: "SOC", value: "6" },
  ];

  const buyerIDTypes = [
    { label: "NUIS", value: "1" },
    { label: "ID", value: "2" },
    { label: "PASS", value: "3" },
    { label: "VAT", value: "4" },
    { label: "TAX", value: "5" },
    { label: "SOC", value: "6" },
  ];

  const clearDialog=()=>setPartiesDialog({open:false,id:null,party:null})

 const isEmptyHelper = (value) => {
  if (value === null || value === "" || value === undefined ) return true;
  return false;
};

  const handleInvoiceBuyerChange = async (
    e,
    selectKey,
    selectValue,
    length,
    reason
  ) => {
    let key = e ? e.target.name : selectKey;
    let value = e ? e.target.value : selectValue;
    if (key === "buyer") {
      let customer = value;
      if (customer?.label && customer?.value) {
        delete customer["label"];
        delete customer["value"];
      }
      let invoiceContent={}

    let currencyChangeApprove = false;
    const items = invoiceState.items
    if ( !edit && customer && !isEmptyHelper(customer?.currencyDefault) && customer?.currencyDefault!=invoiceState?.currency  && (items.length > 1 || (items.length == 1 && items?.[0] && items?.[0].name != ""))) {
      currencyChangeApprove = await func.swalAlert({ title: t("invoice.currencyChangeCustomer",{currency:customer.currencyDefault,oldCurrency:invoiceState.currency }), t })
    }else if(!edit && customer && customer?.currencyDefault!=invoiceState?.currency ){
      invoiceContent.currency= customer?.currencyDefault ?? invoiceState?.currency
    }

    if (currencyChangeApprove) {
      const newCurrency = customer?.currencyDefault
      invoiceContent = {
        currency: newCurrency ?? invoiceState?.currency,
        items: !edit && currencyChangeApprove ? [{ ...stateDefault.items[0] }] : [...invoiceState.items],
        bankAccount: null,
        rate: newCurrency != "ALL" ? "" : "1"
      }
    }
      inputRef.current.blur();
      inputRef.current.focus();
      setInvoiceState((invoiceState) => {
        invoiceContent = {
          ...invoiceState,
          ...invoiceContent,
          parties: {
            ...invoiceState.parties,
            customerId:customer?.id,
            buyer: {
              tin: customer?.idValue,
              name: customer?.name ?? "",
              address: customer?.address ?? "",
              country: func.getFullCountry(customer?.country, false),
              town: customer?.town ?? "",
              email: customer?.email ?? null,
              buyerIDType: invoiceState.einvoice
                ? buyerIDTypes[0].label
                : !invoiceState?.einvoice && customer?.idType
                  ? customer?.idType
                  :null,
            },
          },
        }
        return invoiceContent
      });
      if(selectValue){
        validateInvoice({ setErrors, state: invoiceContent,setPartiesDialog,validateOnlyParties:true,t })
      }
    } else {
      if (reason?.action === "input-blur" || reason?.action === "menu-close")
        return;
      if (reason?.action === "set-value") return;
      value = length != undefined ? value.slice(0, length) : value;

      let customerKey = key;
      let customerValue = value;

      if (key == "buyerIDType") {
        customerKey = "type";
        customerValue = buyerIDTypes.find((type) => type.label == value).value;
      }
      setInvoiceState((invoiceState) => ({
        ...invoiceState,
        parties: {
          ...invoiceState.parties,
          buyer: {
            ...invoiceState.parties.buyer,
            [key]: value,
          },
        },
      }));
    }
  };


  const handleInvoiceSellerChange = (e, selectKey, selectValue, length, reason) => {

      let key = e ? e.target.name : selectKey;
      let value = e ? e.target.value : selectValue;

      if (key === "seller") {
        let seller=value
        if(seller?.label && seller?.value){
          delete seller["label"]
          delete seller["value"]
        }
        const {idValue:tin="",name="",address="",town="",country="",idType:sellerIDType="NUIS" } =seller ?? {}
        setInvoiceState((invoiceState) => ({
          ...invoiceState,
          parties: {
            ...invoiceState.parties,
            supplierId:seller?.id,
            seller: {
              tin: tin,
              name: name,
              address: address,
              country: func?.getFullCountry(country),
              town:town,
              sellerIDType
            },
          },
        }));
        inputRefSeller.current.blur();
        inputRefSeller.current.focus();
      } else {
        if(reason?.action === "input-blur" || reason?.action === "menu-close") return
        if(reason?.action === "set-value") return
        value = length != undefined ? value.slice(0, length) : value;
      
        let customerKey=key
        let customerValue=value
      
        if(key=="sellerIDTypes"){
          customerKey="type"
          customerValue=sellerIDTypes.find(type=>type.label==value).value
        }
        setInvoiceState((invoiceState) => ({
          ...invoiceState,
          parties: {
            ...invoiceState.parties,
            seller: {
              ...invoiceState.parties.seller,
              [key]: value,
            },
          },
        }));
      }
  };


  const customStyles = {
    ...compactSelect,
    control: (styles, state) => ({
      ...compactSelect.control(styles, state),
      borderColor: errors?.["parties.buyer.name"] ? "#dc3545" : (state.isFocused ? "#28f0d8" : "#d1d5db"),
      "&:hover": {
        borderColor: errors?.["parties.buyer.name"] ? "#dc3545" : (state.isFocused ? "#28f0d8" : "#9ca3af"),
      },
    }),
  };

  const hasNoCustomer=useMemo(()=>{
    const {country,id,...buyerWoCountry} = invoiceState.parties.buyer
    return isObjectEmpty({object:buyerWoCountry})
  },[invoiceState?.parties?.buyer])

    const onAddEditBuyerHandle=()=>{
    let {buyerIDType,...buyer} = invoiceState?.parties?.buyer ?? {};
    setPartiesDialog({open:true,id:invoiceState?.parties?.customerId,party:partiesDialogTypes.buyer,contact:sellerPartyToConnection({party:{...buyer,idType:buyerIDType},contactType:"CUSTOMER"})})
  }


  const addEditCustomer = () => {
    
    const showEdit = (invoiceState?.parties?.customerId || invoiceState?.parties?.buyer?.name || invoiceState?.parties?.buyer?.tin) && (invoiceState?.status?.status? invoiceState?.status?.status!=="APPROVED":true)
    
    if(disabled) return <></>
    return (
      <div className="d-flex align-items-center gap-2">
          {invoiceState.selfInvoice ? (invoiceState?.parties.seller?.id  ) : (showEdit && !hasNoCustomer)  && (
            <>
              <Tooltip target=".custom-target-icon" />
              <i
                onClick={() => onAddEditBuyerHandle() }
                className="custom-target-icon pi pi-user-edit p-text-secondary p-overlay-badge"
                data-pr-tooltip={t("invoice.editBuyer")}
                data-pr-position="right"
                data-pr-my="left center-2"
                style={{ fontSize: "1.25rem", cursor: "pointer" }}
              ></i>
            </>
          )}
          {!hasNoCustomer &&<>
          <Tooltip target=".custom-target-icon-plus" />
          <i
            onClick={() => setPartiesDialog({open:true,id:null,party:partiesDialogTypes.buyer})}
            className="custom-target-icon-plus pi pi-user-plus text-success p-overlay-badge"
            data-pr-tooltip={t('invoice.addBuyer')}
            data-pr-position="right"
            data-pr-my="left center-2"
            style={{ fontSize: "1.25rem", cursor: "pointer" }}
          ></i>
          </>}

          <i
            onClick={() => setCustomers(true)}
            className="custom-target-icon-plus pi pi-list p-overlay-badge"
            data-pr-tooltip={t('invoice.byerList')}
            data-pr-position="right"
            data-pr-my="left center-2"
            style={{ fontSize: "1.25rem", cursor: "pointer" }}
          ></i>

        <Dialog
          header={t("taxpayer.buyerList")}
          visible={customers}
          onHide={() => setCustomers(false)}
          style={{ width: "70vw",minHeight:"88%" }}
          breakpoints={{ "960px": "75vw", "641px": "100vw" }}
          closable={true}
          dismissableMask={true}
        >
          <MySuppliers  />
        </Dialog>
      </div>
    );
  };

  const onAddEditSellerHandle=()=>{
    let {sellerIDType,...seller} = invoiceState?.parties?.seller ?? {};
    setPartiesDialog({open:true,id:invoiceState?.parties?.supplierId,party:partiesDialogTypes.seller,contact:sellerPartyToConnection({party:{...seller,idType:sellerIDType},contactType:"SUPPLIER"})})
  }

  const addEditSupplier = () =>{
    if(disabled) return <></>
    return (
      <>
      {(invoiceState.selfInvoice || correctionOfSelfInvoice )&& !disabled &&  (
        <div>
          <Tooltip target=".custom-target-icon" />
          <i
            onClick={() => onAddEditSellerHandle()}
            className="custom-target-icon pi pi-user-edit p-text-secondary p-overlay-badge"
            data-pr-tooltip={t("invoice.editSeller")}
            data-pr-position="right"
            data-pr-my="left center-2"
            style={{ fontSize: "1.5rem", cursor: "pointer", marginLeft:'5px'}}
          ></i>
        </div>
      )}
      </>
    )
  }

  

  const { town:buyerTown,country:buyerCountry,tin:buyerTin } = invoiceState?.parties?.buyer ?? {}
  const { town:sellerTown,country:sellerCountry,tin:sellerTin } = invoiceState?.parties?.seller ?? {}

  const correctionOfSelfInvoice = (invoiceState?.profileId == "P10" && invoiceState.correctionOfSelfInvoice && invoiceState?.type === "384")
  


  const onNoCustomerChange= (e) => {
    const defaultBuyer= {
      tin: null,
      name: "",
      address: "",
      country: "Albania",
      town: "",
      buyerIDType: "NUIS",
    }
    setInvoiceState((state)=>({
      ...state,
      parties:{
        ...state.parties,
        buyer:hasNoCustomer ? defaultBuyer:{
            tin: null,
            name: null,
            address: null,
            country: null,
            town: null,
            buyerIDType: null,
        }
      }
    }))
  }

  const onDataSuccess = (contact) => {
     setErrors((errors)=>{
      const newErrors={}
      Object.keys(errors).forEach(key=>{
        if(!key.includes("parties")){
          newErrors[key]=errors[key]
        }
      })
      return newErrors
    })

    if( partiesDialog.party==partiesDialogTypes.seller){
     handleInvoiceSellerChange(null, 'seller', contact);
    }else if(partiesDialog.party==partiesDialogTypes.buyer){
      handleInvoiceBuyerChange(null, 'buyer', contact);
    }
    clearDialog()

  }

  const transformedErrors = useMemo(() => {
    if (!partiesDialog.open) return {};

    const transformed = {};
    const prefix = partiesDialog.party === partiesDialogTypes.buyer
      ? "parties.buyer."
      : "parties.seller.";

    Object.keys(errors).forEach(key => {
      if (key.startsWith(prefix)) {
        const fieldName = key.replace(prefix, "");
        transformed[fieldName] = errors[key];
      }
    });

    return transformed;
  }, [errors, partiesDialog.open, partiesDialog.party])

  return (
    <div>
      <div className="d-none parties-header">
        <label className="fw-bold header d-flex justify-content-between gap-1">
           <div>{t("invoice.seller")}</div>
            {addEditSupplier()}
            <Dialog
              header={partiesDialog?.id?t("mySuppliers.editContact"):t("mySuppliers.addContact")}
              visible={partiesDialog.open}
              onHide={clearDialog}
              style={{ width: "900px",minHeight:"90%" }}
              breakpoints={{ "960px": "80vw", "641px": "100vw" }}
            >
              {partiesDialog.open&& <EditAddSupplies
                contact={partiesDialog.contact}
                setInvoiceState={setInvoiceState}
                errors={transformedErrors}
                setPartiesDialog={setPartiesDialog}
                id={partiesDialog?.id}
                fromInvoice={true}
                onDataSuccess={(contact)=>{
                  onDataSuccess(contact)
                }}
              />}
            </Dialog>

        </label>
        <label className="fw-bold header d-none d-flex justify-content-between gap-1">
          <div>{t("invoice.buyer")}</div>
          {!invoiceState.selfInvoice && !correctionOfSelfInvoice && addEditCustomer(false) }
        </label>
      </div>

      <div className="row mx-2 mx-md-auto">
        <div className="col-12 col-md-6 pr-1 mr-0 pl-0 ml-0 parties-col">
          <div className="d-flex justify-content-between align-items-center" style={{height: "1.4rem", marginBottom: "0.25rem"}}>
            <label className="fw-bold mb-0 header" style={{fontSize: "0.95rem"}}>{t("invoice.seller")}</label>
            {addEditSupplier()}
          </div>
          {(invoiceState.selfInvoice || correctionOfSelfInvoice) && !disabled && (
            <div>
              <TaxPayerSearch
                size="sm"
                onSelect={(taxPayer)=>{onSellerChange(taxPayer)}}
                disabled={disabled}
              />
            </div>
          )}
      
            <div>
      
            <div>
              <div className="field-label">{t("invoice.name")}</div>
             
              <div className="seller-invoice ">
              {
                 ( invoiceState.selfInvoice || correctionOfSelfInvoice) ?
                    <AsyncSelect
                    styles={customStyles}
                    placeholder={t("taxpayer.buyername")}
                    name="name"
                    ref={inputRefSeller}
                    components={{
                      DropdownIndicator: () => null,
                      IndicatorSeparator: () => null,
                    }}
                    className={`basic-multi-select valid ${disabled ? 'select-disabled-show-value' : ''}`}
                    onChange={(value) => {
                      handleInvoiceSellerChange(null, "seller", value);
                    }}
                    isDisabled={(invoiceState.selfInvoice || correctionOfSelfInvoice ? disabled : true)}
                    // cacheOptions
                    // value={invoiceState.parties.seller.label}
                    inputValue={invoiceState?.parties?.seller?.name ?? ""}
                    loadOptions={(name)=>{const test=loadOptionsForContacts(name,"SUPPLIER"); return test}}
                    defaultOptions={false}
                    onInputChange={(input, reason) =>
                      handleInvoiceSellerChange(null, "name", input, 200, reason)
                    }
                    isClearable={true}
                  />

              :
                  invoiceState?.parties?.seller?.name
              }
             
              </div>
            </div>
            <div>
              <div>
                <div className="field-label">{invoiceState.parties.seller.sellerIDType}</div>
                <div className="seller-invoice">
                  {invoiceState.parties.seller.tin}
                </div>
              </div>
            </div>
            <div>
              <div className="field-label">{t("customers.address")}</div>
              <div className="seller-invoice">
                {invoiceState.parties.seller.address}
              </div>
            </div>
            <div>
              <div className="field-label">{t("taxpayer.city")} / {t("taxpayer.country")}</div>
              <div className="seller-invoice">
                {sellerTown ?? ""}{sellerCountry && sellerTin?","+sellerCountry:""}
              </div>
            </div>
          </div>

        </div>
        
        <div className="col-12 col-md-6 pr-0 mr-0 pl-1 ml-0 parties-col">
          <div className="d-flex justify-content-between align-items-start" style={{marginBottom: "0.25rem"}}>
            <label className="fw-bold mb-0 header" style={{fontSize: "0.95rem", lineHeight: "1.5rem"}}>{t("invoice.buyer")}</label>
            {!invoiceState.selfInvoice && !correctionOfSelfInvoice && addEditCustomer(false)}
          </div>
          {!disabled && (
            <div>
              <TaxPayerSearch
                size="sm"
                onSelect={(taxPayer)=>{onBuyerChange(taxPayer)}}
                disabled={disabled}
              />
            </div>
          )}
          <div>
            <div>
              <div>
                <div className="d-flex justify-content-between align-items-center">
                  <label className="field-label" style={{ whiteSpace: "nowrap" }}>
                    {t("taxpayer.buyername")}
                    {/* <PopOver title="Text Buyer Name" /> */}
                  </label>
                  {!invoiceState?.einvoice && <div className="d-flex align-items-center justify-content-end custom-control custom-checkbox" style={{ whiteSpace: "nowrap", flexShrink: 0,margin:0,marginLeft:10 }}>
                <input
                  type="checkbox"
                  className="custom-control-input"
                  id="noCustomer"
                  name="noCustomer"
                  disabled={disabled}
                  checked={hasNoCustomer}
                  onChange={onNoCustomerChange}
                />
                 <label htmlFor="noCustomer" className="custom-control-label" style={{ paddingTop: "2px", whiteSpace: "nowrap" }}>
                  {t("invoice.noCustomer")}
                </label>
              </div>}
                </div>
                <AsyncSelect
                  styles={customStyles}
                  placeholder={t("taxpayer.buyername")}
                  name="name"
                  ref={inputRef}
                  components={{
                    DropdownIndicator: () => null,
                    IndicatorSeparator: () => null,
                  }}
                  className={`basic-multi-select valid ${(invoiceState.selfInvoice || correctionOfSelfInvoice || disabled) ? 'select-disabled-show-value' : ''}`}
                  onChange={(value) => {
                    handleInvoiceBuyerChange(null, "buyer", value);
                  }}
                  cacheOptions
                  value={invoiceState.parties?.buyer?.name ?? ""}
                  inputValue={invoiceState.parties.buyer.name ?? ""}
                  loadOptions={(name)=>{const test=loadOptionsForContacts(name,"CUSTOMER"); return test}}
                  defaultOptions={false}
                  onInputChange={(input, reason) =>
                    handleInvoiceBuyerChange(null, "name", input, 200, reason)
                  }
                  isClearable={true}
                  isDisabled={invoiceState.selfInvoice || correctionOfSelfInvoice || disabled}
                />
                {errors?.["parties.buyer.name"] && invoiceState?.parties?.buyer?.name?.length==0 && <FontAwesomeIcon icon={faCircleExclamation} style={{color: "#eb0000", position:'absolute',top:96,right:24}} />}
              </div>

              <div className="field-label">
                {" "}
                {invoiceState?.parties?.buyer?.buyerIDType || ""}
              </div>
              <div className="seller-invoice">
                {invoiceState.parties.buyer.tin || ""}
              </div>
            </div>

            <div>
              <div className="field-label">{t("taxpayer.address")}</div>
              <div className="seller-invoice">
                {invoiceState.parties.buyer.address || ""}
              </div>
            </div>
            <div>
              <div className="field-label">{t("taxpayer.city")} / {t("taxpayer.country")}</div>
              <div className="seller-invoice">
                {buyerTown ?? "-"}{buyerCountry && buyerTin ? "," + buyerCountry : ""}
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default DemoParties;
